import { useAppState } from 'AppContextProvider'
import ReinforcementScreenContainer from 'Components/ReinforcementScreen/ReinforcementMain'
import { FC, useMemo } from 'react'
import { Trans } from 'react-i18next'
import { ReinforcementDescriptionHighlight, ReinforcementTitleHighlight } from '../Typography'
import { ReinforcementScreenBackgrounds, ReinforcementScreenContent } from 'types/reinforcementScreenTypes'
import { images } from 'images'

const stepImages: ReinforcementScreenBackgrounds<'1Or2' | '3Or4'> = {
  m: {
    '1Or2': images.happyWeightInfoMale1Or2,
    '3Or4': images.happyWeightInfoMale3Or4
  },
  f: {
    '1Or2': images.happyWeightInfoFemale1Or2,
    '3Or4': images.happyWeightInfoFemale3Or4
  }
}

interface HappyWeightInfoScreenProps {
  onContinue: (shouldSkipNext?: boolean) => Promise<void>
}

const HappyWeightInfoScreen: FC<HappyWeightInfoScreenProps> = ({ onContinue }) => {
  const { appState } = useAppState()

  const screenContent = useMemo((): ReinforcementScreenContent => {
    const { gender = 'f', last_happy_weight: lastHappyWeight } = appState.selections ?? {}
    const genderKey = (gender === 'o' ? 'f' : gender) as IGender
    const firstOptions = ['less_than_1_year', '1_to_2_years']
    const goalType = firstOptions.includes(lastHappyWeight) ? '1Or2' : '3Or4'
    return {
      localePrefix: `reinforcementScreens.happy_weight_info.${genderKey}.${goalType}`,
      backgroundImagePath: stepImages[genderKey]![goalType]
    }
  }, [appState.selections?.last_happy_weight, appState.selections?.gender])

  return (
    <ReinforcementScreenContainer
      title={
        <Trans
          i18nKey={`${screenContent.localePrefix}.title`}
          components={{ em: <ReinforcementTitleHighlight /> }}
        />
      }
      description={
        <Trans
          i18nKey={`${screenContent.localePrefix}.body`}
          components={{ em: <ReinforcementDescriptionHighlight /> }}
        />
      }
      backgroundImage={screenContent.backgroundImagePath}
      onContinue={onContinue}
    />
  )
}

export default HappyWeightInfoScreen
